import ExcelJS from 'exceljs';
import moment from 'moment';

const StaffAddressLabelsReportExcel = async (data: any) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Staff Address Labels');

  // Add title
  worksheet.mergeCells('A1:E1');
  worksheet.getCell('A1').value = 'Staff Address Labels Report';
  worksheet.getCell('A1').alignment = { horizontal: 'center' };
  worksheet.getCell('A1').font = { size: 16, bold: true };

  // Add current date
  const todayDate = moment().format('MM-DD-YYYY');
  worksheet.mergeCells('A2:E2');
  worksheet.getCell('A2').value = `Date: ${todayDate}`;
  worksheet.getCell('A2').alignment = { horizontal: 'center' };

  // Filter out completely empty records - same logic as PDF version
  const validData = data.filter((item: any) => {
    const name = [item.FirstName, item.LastName].filter(Boolean).join('').trim();
    const street = (item.Address || item.Street || '').trim();
    const city = (item.City || '').trim();
    const state = (item.State || '').trim();
    const zip = (item.Zipcode || item.ZipCode || '').trim();
    return name || street || city || state || zip;
  });

  if (validData.length === 0) {
    worksheet.mergeCells('A4:E4');
    worksheet.getCell('A4').value = 'No data available';
    worksheet.getCell('A4').alignment = { horizontal: 'center' };
    worksheet.getCell('A4').font = { italic: true };
  } else {
    // Add table headers
    worksheet.getRow(4).values = ['First Name', 'Last Name', 'Address', 'City', 'State', 'Zip Code'];
    worksheet.getRow(4).font = { bold: true };
    worksheet.getRow(4).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE0E0E0' }
    };

    // Add data rows
    validData.forEach((item: any, index: number) => {
      const rowNumber = index + 5;
      const firstName = item.FirstName || '';
      const lastName = item.LastName || '';
      const address = item.Address || item.Street || '';
      const city = item.City || '';
      const state = item.State || '';
      const zipCode = item.Zipcode || item.ZipCode || '';

      worksheet.addRow([firstName, lastName, address, city, state, zipCode]);
    });

    // Apply formatting to data rows
    worksheet.eachRow({ includeEmpty: false }, function (row, rowNumber) {
      if (rowNumber >= 4) { // Skip title rows
        // Add borders
        row.eachCell({ includeEmpty: false }, function (cell) {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
        });

        // Center alignment for better readability
        row.alignment = { 
          vertical: 'middle', 
          horizontal: 'left',
          wrapText: true
        };

        // Add some row height for better readability
        row.height = 20;
      }
    });

    // Auto-fit column widths
    worksheet.columns.forEach((column, index) => {
      let maxLength = 0;
      if (column.eachCell) {
        column.eachCell({ includeEmpty: false }, function (cell) {
          const columnLength = cell.value ? cell.value.toString().length : 0;
          if (columnLength > maxLength) {
            maxLength = columnLength;
          }
        });
      }
      
      // Set minimum and maximum widths
      const width = Math.min(Math.max(maxLength + 2, 15), 30);
      column.width = width;
    });

    // Freeze the header row
    worksheet.views = [
      { state: 'frozen', ySplit: 4 }
    ];
  }

  // Return the Excel buffer
  const buffer = await workbook.xlsx.writeBuffer();
  return buffer;
};

export default StaffAddressLabelsReportExcel;
